import axiosFlow from '@/services/axios/axiosFlow'
import { isNullOrUndefined } from '@/utils/functions'

export default class DashboardService {
  static async getFilaMediaTicketsAgentes(filasIds, dataInicio, dataFim) {
    const params = new URLSearchParams()

    filasIds.forEach(number => {
      params.append('FilaIdList', number)
    })
    if (dataInicio) {
      params.append('Inicio', dataInicio)
    }
    if (dataFim) {
      params.append('Fim', dataFim)
    }

    return axiosFlow.get(`dashboard/fila/media-tickets-agentes?${params}`).then(res => res.data.data.total)
  }

  static async getFilaCapacidadeAtendimento(filasIds) {
    const params = new URLSearchParams()

    filasIds.forEach(number => {
      params.append('FilaIdList', number)
    })

    return axiosFlow.get(`dashboard/fila/capacidade-atendimento?${params}`).then(res => res.data.data.total)
  }

  static async getFilaMediaEspera(filasIds, dataInicio, dataFim) {
    const params = new URLSearchParams()

    filasIds.forEach(number => {
      params.append('FilaIdList', number)
    })
    if (dataInicio) {
      params.append('Inicio', dataInicio)
    }
    if (dataFim) {
      params.append('Fim', dataFim)
    }

    return axiosFlow.get(`dashboard/fila/media-espera?${params}`).then(res => res.data.data.total)
  }

  static async getFilaTotalTicketsCategoriaStatus(filasIds, dataInicio, dataFim) {
    const params = new URLSearchParams()

    filasIds.forEach(number => {
      params.append('FilaIdList', number)
    })
    if (dataInicio) {
      params.append('Inicio', dataInicio)
    }
    if (dataFim) {
      params.append('Fim', dataFim)
    }

    return axiosFlow.get(`dashboard/fila/total-tickets-categoria-status?${params}`).then(res => res.data.data)
  }

  static async getFilaTotalTicketsStatus(filaId, dataInicio, dataFim, ativo) {
    const params = new URLSearchParams()

    if (filaId) {
      params.append('FilaId', filaId)
    }
    if (dataInicio) {
      params.append('Inicio', dataInicio)
    }
    if (dataFim) {
      params.append('Fim', dataFim)
    }
    if (!isNullOrUndefined(ativo)) {
      params.append('IsActive', ativo)
    }

    return axiosFlow.get(`dashboard/fila/total-tickets-status?${params}`).then(res => res.data.data)
  }

  static async getFilaTotalTicketsFilaCanal(filaId, dataInicio, dataFim) {
    const params = new URLSearchParams()

    if (filaId) {
      params.append('FilaId', filaId)
    }
    if (dataInicio) {
      params.append('Inicio', dataInicio)
    }
    if (dataFim) {
      params.append('Fim', dataFim)
    }

    return axiosFlow.get(`dashboard/fila/total-tickets-fila-canal?${params}`).then(res => res.data.data)
  }

  static async getFilaTotalAgentes(filasIds) {
    const params = new URLSearchParams()

    filasIds.forEach(number => {
      params.append('FilaIdList', number)
    })

    return axiosFlow.get(`dashboard/fila/total-agentes?${params}`).then(res => res.data.data)
  }

  static async getFilaTicketsCategoriaStatus(filasIds, dataInicio, dataFim) {
    const params = new URLSearchParams()

    filasIds.forEach(number => {
      params.append('FilaIdList', number)
    })
    if (dataInicio) {
      params.append('Inicio', dataInicio)
    }
    if (dataFim) {
      params.append('Fim', dataFim)
    }

    return axiosFlow.get(`dashboard/fila/tickets-categoria-status?${params}`).then(res => res.data.data)
  }

  static async getEquipeCapacidadeDeAtendimento(equipeId, agenteId) {
    const params = new URLSearchParams()

    if (equipeId) {
      params.append('EquipeId', equipeId)
    }
    if (agenteId) {
      params.append('AgenteId', agenteId)
    }

    return axiosFlow.get(`dashboard/equipe/capacidade-atendimento?${params}`).then(res => res.data.data.total)
  }

  static async getEquipeMediaTicketsAgentes(equipeId, dataIncio, dataFim) {
    const params = new URLSearchParams()

    if (equipeId) {
      params.append('EquipeId', equipeId)
    }
    if (dataIncio) {
      params.append('Inicio', dataIncio)
    }
    if (dataFim) {
      params.append('Fim', dataFim)
    }

    return axiosFlow.get(`dashboard/equipe/media-tickets-agentes?${params}`).then(res => res.data.data.total)
  }

  static async getEquipeMediaEspera(equipeId, agenteId, dataIncio, dataFim) {
    const params = new URLSearchParams()

    if (equipeId) {
      params.append('EquipeId', equipeId)
    }
    if (agenteId) {
      params.append('AgenteId', agenteId)
    }
    if (dataIncio) {
      params.append('Inicio', dataIncio)
    }
    if (dataFim) {
      params.append('Fim', dataFim)
    }

    return axiosFlow.get(`dashboard/equipe/media-espera?${params}`).then(res => res.data.data.total)
  }

  static async getTotalTicketsCategoriaStatus(equipeId, agenteId, dataIncio, dataFim) {
    const params = new URLSearchParams()

    if (equipeId) {
      params.append('EquipeId', equipeId)
    }
    if (agenteId) {
      params.append('AgenteId', agenteId)
    }
    if (dataIncio) {
      params.append('Inicio', dataIncio)
    }
    if (dataFim) {
      params.append('Fim', dataFim)
    }

    return axiosFlow.get(`dashboard/equipe/total-tickets-categoria-status?${params}`).then(res => res.data.data)
  }

  static async getTemposMediosEntreRespostasDeAgentes(equipeId, agenteId, dataInicio, dataFim) {
    const params = new URLSearchParams()

    if (equipeId) { params.append('EquipeId', equipeId) }
    if (agenteId) { params.append('AgenteId', agenteId) }
    if (dataInicio) { params.append('Inicio', dataInicio) }
    if (dataFim) { params.append('Fim', dataFim) }

    return axiosFlow.get(`dashboard/equipes/tmer?${params.toString()}`).then(res => res.data.data)
  }

  static async getTempoDePrimeiraRespostaAposTransbordo(equipeId, agenteId, dataInicio, dataFim) {
    const params = new URLSearchParams()

    if (equipeId) { params.append('EquipeId', equipeId) }
    if (agenteId) { params.append('AgenteId', agenteId) }
    if (dataInicio) { params.append('Inicio', dataInicio) }
    if (dataFim) { params.append('Fim', dataFim) }

    return axiosFlow.get(`dashboard/equipes/tpr?${params.toString()}`).then(res => res.data.data)
  }

  static async getSituacoesDeAgentesDeUmaEquipeAsync(equipeId) {
    return axiosFlow.get(`dashboard/runtime/agentes-situacoes?EquipeId=${equipeId}`).then(res => res.data.data)
  }
}
